import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users } from '@phosphor-icons/react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LiveCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/calc-stats`)
      .then((r) => {
        if (!cancelled) setCount(r.data.total);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (count == null || count < 50) return null;
  return (
    <div
      data-testid="live-counter"
      className="inline-flex items-center gap-2 mt-6 border border-neutral-300 bg-white/80 backdrop-blur px-3 h-9 font-mono text-xs uppercase tracking-widest"
    >
      <Users size={14} weight="bold" />
      <span className="tnum">{count.toLocaleString('de-DE')}</span>
      <span className="text-neutral-600 normal-case tracking-normal">Pendler haben bereits berechnet</span>
    </div>
  );
}
